import * as R from 'ramda'

import { stringify } from 'utils/json'

export const getCategories = R.pipe(
  R.values,
  R.pluck('category'),
  R.filter(R.identity),
  R.sort(R.comparator(R.lt)),
  R.uniq,
  R.memoizeWith(stringify, R.identity),
)

/**
 * The competencies a job profile asks the report to present, or null when it
 * makes no such request.
 *
 * This is independent of the competencies selected for scoring: a score is
 * calculated for every competency regardless of the selection, so a profile may
 * name any of them. Callers fall back to the selected ones themselves, since
 * they differ in how they order the result.
 */
export const getDisplayCompetencies = (profile: {
  displayCompetencies?: string[]
}): string[] | null => {
  const shown = profile?.displayCompetencies

  return shown == null || R.isEmpty(shown) ? null : shown
}
